import { ReactNode } from "react";
import colors from "../../scss/colors.module.scss";

export const CHART_COLORS = {
  achieved: colors.lightGreen,
  notTracking: colors.dataVizOrange,
  offTrack: colors.lightGrayAccent,
  default: colors.amwayWhite,
  black: colors.amwayBlack,
  disabled: colors.lightGrayAccent,
};

type volume = {
  actual: number;
  formatted: string;
};

export type PeriodsProgressCircleProps = {
  targetAmount: volume;
  currentAmount: volume;
  period: string;
  tracking: boolean;
  disabled: boolean;
  showLegend?: boolean;
  chartTitle?: ReactNode;
};

export type PeriodsProgressCircleLabelOverlayProps = {
  currentVolumeFill: string;
  numFilledSlices: number;
} & PeriodsProgressCircleProps;
